import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MoneyPageFAQ from '../components/MoneyPageFAQ';
import MoneyPageHero from '../components/MoneyPageHero';
import { ComparisonSection, FeaturesSection, HowItWorksSection, ProblemSection } from '../components/MoneyPageSections';
import { moneyPageSchema } from '../data/moneyPageContent';
import SafeIcon from '../common/SafeIcon';

const AiReceptionistPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'AI Receptionist for Small Business | AutoReception';
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify(moneyPageSchema);
    document.head.appendChild(schema);
    return () => schema.remove();
  }, []);

  const goToContact = () => {
    navigate('/');
    window.setTimeout(() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }), 100);
  };

  return (
    <div className="animate-in fade-in duration-700">
      <MoneyPageHero onContactClick={goToContact} />
      <ProblemSection />
      <FeaturesSection />
      <section className="border-y border-slate-800 bg-slate-950 px-4 py-20 text-center sm:px-6 lg:px-8">
        <p className="mb-4 text-sm font-bold uppercase tracking-widest text-blue-400">Hear it in action</p>
        <h2 className="text-4xl font-extrabold text-white">Listen to AutoReception handle real customer calls.</h2>
        <p className="mx-auto mt-4 max-w-2xl text-slate-400">Try sample scenarios including emergency plumbing intake, dental appointment rescheduling, and a general law firm inquiry.</p>
      </section>
      <ComparisonSection />
      <HowItWorksSection />
      <MoneyPageFAQ />
      <section className="relative overflow-hidden bg-blue-700 px-4 py-24 text-center sm:px-6 lg:px-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.16),transparent_55%)]" />
        <div className="relative mx-auto max-w-3xl">
          <h2 className="text-4xl font-extrabold text-white md:text-5xl">Stop losing paying clients to voicemail.</h2>
          <p className="mt-5 text-lg text-blue-100">Start your free trial, forward your calls, and see how many opportunities your business has been missing.</p>
          <button type="button" onClick={goToContact} className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-lg font-bold text-blue-700 transition hover:bg-blue-50">
            Start Your Free Trial
            <SafeIcon name="ArrowRight" />
          </button>
          <p className="mt-5 text-sm text-blue-100">No hardware required • 5-minute setup • Cancel anytime</p>
        </div>
      </section>
      <section className="px-4 py-16 text-center sm:px-6 lg:px-8">
        <p className="text-slate-400">
          Learn more about the <Link to="/best-ai-receptionist-for-small-business" className="text-blue-400 hover:underline">best AI receptionist for small business</Link> or explore our <Link to="/virtual-receptionist-for-small-business" className="text-blue-400 hover:underline">virtual receptionist for small business</Link> guide.
        </p>
      </section>
    </div>
  );
};

export default AiReceptionistPage;